import type { FC } from 'react';
import cx from 'clsx';
import { Divider } from '@kcd/design-system';

import type { OAISchema } from '~/types/openapi';

type Props = OAISchema['MarketProductVendorResponse'] & {
  isInnerBottomSheet?: boolean;
  className?: string;
};

const VendorInformation: FC<Props> = ({
  vendorName,
  representativeName,
  businessNumber,
  mailOrderNumber,
  address,
  asContact,
  isInnerBottomSheet = true,
  className,
}) => {
  return (
    <div className={cx([!isInnerBottomSheet && 'py-16 px-20', className])}>
      {!isInnerBottomSheet && (
        <>
          <span className="text-normal typo-title100-semibold">
            판매자 정보
          </span>
          <Divider size={16} />
        </>
      )}

      <div className="flex flex-col gap-4">
        {[
          {
            label: '상호명',
            text: vendorName,
          },
          {
            label: '대표자',
            text: representativeName,
          },
          {
            label: '사업자등록번호',
            text: businessNumber,
          },
          {
            label: '통신판매신고번호',
            text: mailOrderNumber,
          },
          {
            label: '사업장 소재지',
            text: address,
          },
          {
            label: '판매자 연락처',
            text: asContact,
          },
        ].map(({ label, text }) => (
          <div key={label} className="flex justify-between">
            <span className="text-hint typo-caption100-regular">{label}</span>
            <span className="text-right text-paragraph typo-caption100-semibold">
              {text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VendorInformation;
